import { Box, Divider, Stack, Typography } from "@mui/material";
import { ReviewCompoundStep } from "@/domain/eventInstance.interface";
import { PhotoViewer } from "./PhotoViewer";
import { FormDisplay } from "./FormDisplay";
import { VideoPlayer } from "./VideoPlayer";
import { GenericPlaceholder } from "./GenericPlaceholder";

interface Props {
	steps: ReviewCompoundStep[];
	mode?: "view" | "review";
}

const renderStep = (step: ReviewCompoundStep, mode: "view" | "review") => {
	switch (step.validationType) {
		case "PHOTOS":
			return <PhotoViewer photos={step.photos ?? []} mode={mode} />;
		case "FORM":
			return (
				<FormDisplay
					formConfig={step.formConfig}
					responses={step.formResponses}
					mode={mode}
				/>
			);
		case "WATCH_VIDEO":
		case "CAPTURE_VIDEO":
			return <VideoPlayer mode={mode} />;
		default:
			return (
				<GenericPlaceholder validationType={step.validationType} mode={mode} />
			);
	}
};

export const CompoundView = ({ steps, mode = "view" }: Props) => {
	if (!steps?.length) {
		return (
			<Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
				No compound steps configured.
			</Typography>
		);
	}

	return (
		<Stack divider={<Divider flexItem />}>
			{steps.map((step, idx) => (
				<Box key={step.eventId} sx={{ p: 2 }}>
					<Typography variant="subtitle2" sx={{ mb: 1 }}>
						Step {idx + 1} of {steps.length}: {step.name}
						{!step.required && (
							<Typography
								component="span"
								variant="caption"
								color="text.secondary"
								sx={{ ml: 1 }}
							>
								(optional)
							</Typography>
						)}
					</Typography>
					{renderStep(step, mode)}
				</Box>
			))}
		</Stack>
	);
};
